import SiteShell from "../components/SiteShell";

// const scaleStats = [
//   { value: "1 Cr+", label: "Customers Reach" },
//   { value: "450+", label: "Cities Presence" },
//   { value: "12K+", label: "Merchant Points" },
//   { value: "< 3 min", label: "Loan Journey" },
// ];

// const milestones = [
//   {
//     title: "2026",
//     text: "Founded with a mission to bring digital finance into everyday assisted touchpoints. Launched high-speed kiosk onboarding stack with secure KYC and consent architecture. Scaled deployment blueprint across urban and semi-urban partner networks. Building India's most reliable assisted credit infrastructure for salaried users.",
//   },
// ];

// const values = [
//   {
//     title: "Customer Obsession",
//     text: "Every workflow is optimized around transparency, trust, and quick decisions for real users.",
//   },
//   {
//     title: "Execution at Speed",
//     text: "We move fast but never compromise on compliance, quality, or system reliability.",
//   },
//   {
//     title: "Ownership Mindset",
//     text: "Teams own outcomes end-to-end and collaborate deeply across product, risk, and operations.",
//   },
//   {
//     title: "Built for Bharat",
//     text: "We design for real-world conditions: high volume, multilingual needs, and assisted digital journeys.",
//   },
// ];

const leaders = [
  {
    name: "Sachin Mittal",
    role: "Founder & Promoter",
  },
  // {
  //   name: "Rahul Sharma",
  //   role: "Co-Founder & Director",
  //   bio: "Rahul is a seasoned Professional with 19 years of Work Experience in Operations, Procurement, Sourcing, Real estate, Contracts, Vendor Management & Administration in Oil & Gas, Telecom, Manufacturing, Loyalty & Banking industry. Rahul has In-depth understanding of NBFC/banking operations, regulations, and market dynamics in India. Rahul holds Engineering Degree with MBA and PhD In Operations & Supply chain.",
  // },
  {
    name: "Sanjay Sharma",
    role: "Mentor",
    bio: "Sanjay Sharma is a seasoned finance leader with 20+ years of experience in credit risk, strategy, and product innovation. He has driven growth at Unity Small Finance Bank, BharatPe, Indiabulls, Aye Finance, and Religare Finvest, building robust credit frameworks and scalable lending businesses across retail, MSME, and mortgage segments.",
  },
  {
    name: "Rajeev Ranjan",
    role: "Innovator of this Invention",
    bio: "Seasoned 20+ year Banking & Compliance Leader specializng in Credit, Risk, and rigorous RBI regulatory oversight. Proven Success managing high-value structured credit and fortifying risk frameworks with international exposure.",
  },
  {
    name: "Dhanesh Sethia",
    role: "Underwriting & Credit Head",
    bio: "IIT Delhi '20 graduate (OLA, CredFlow,CENTA) blending Product, and Entrepreneurship expertise.",
  },
  {
    name: "Ravi Shekhar",
    role: " Head Product / Engineering",
    bio: "Ravi Shekhar is a seasoned professional with 8 years of experience in Product development campaign coding, His last Association was with ValueFirst Route Mobile. Ravi Shekhar holds a engineering degree in Computer Science.",
    // image:
    //   "/Ravi.jpeg",
  },
  {
    name: "Shyamli Shukla",
    role: "Head Of Marketing",
    bio: "Alumnus of National Institute of Fashion Technology with a Bachelor’s degree in Fashion Communication. A results-driven Social Media Manager with 4.5 years of experience across media, edtech, corporate, and creator ecosystems. Skilled in video production, photography, graphic design, and end-to-end content planning and execution. Worked with leading organizations like Dainik Jagran, Unacademy, and Wipro, along with top digital creators such as Ashish Chanchlani and Samay Raina. Experienced in building engaging digital narratives, scaling social media presence, and managing content strategies that drive visibility and audience growth.",
  },
  {
    name: "Anjali Tomar",
    role: "Senior Software Developer",
    // image:
    //   "/Anjali.jpeg",
  },
  {
    name: "Anant Sharma",
    role: "Software Developer",
  },
  {
    name: "Ritika Syal",
    role: "Data Analytics",
    // image:
    //   "/Ritika.jpeg",
  },

];

const techTeamNames = ["Anjali Tomar", "Ritika Syal", "Anant Sharma"];

function About() {
  const coreLeaders = leaders.filter(
    (leader) => !techTeamNames.includes(leader.name)
  );
  const techTeam = leaders.filter((leader) => techTeamNames.includes(leader.name));

  return (
    <SiteShell route="about" heroHidden={true} highlightsHidden={true}>
      {/* <section className="relative overflow-hidden bg-[#061a2e] pb-20 pt-24 text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_10%,rgba(223,31,45,0.28),transparent_35%),radial-gradient(circle_at_100%_90%,rgba(18,169,191,0.2),transparent_35%)]" />
        <div className="relative z-10 mx-auto grid max-w-[1280px] items-center gap-12 px-6 md:px-10 lg:grid-cols-[1.05fr_0.95fr]">
          <div>
            <p className="inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-1 text-[10px] font-black uppercase tracking-[0.3em] text-sky-200">
              About Us
            </p>
            <h1 className="mt-8 text-4xl font-extrabold leading-tight tracking-tight md:text-7xl">
              FinnCube
              <br />
              Building Trust at Scale and Pioneering the Future of
              Instant Credit
            </h1>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/75 md:text-lg">
              We are transforming assisted finance in India with secure digital
              infrastructure, physical access touchpoints, and high-speed credit
              decisioning for salaried users.
            </p> */}
      {/* <a
              href="#/company"
              className="mt-10 inline-flex rounded-full bg-[#e37921] px-8 py-3 text-xs font-black uppercase tracking-[0.15em] text-white transition hover:bg-[#e37921]"
            >
              Explore Company
            </a> */}
      {/* </div>
          <div className="relative">
            <div className="absolute -inset-4 rounded-[36px] bg-[#df1f2d]/15 blur-2xl" />
            <img
              src="/team_premium_office_1772861377531.png"
              alt="Finn Cube team"
              className="relative h-[420px] w-full rounded-[32px] border border-white/10 object-cover shadow-2xl md:h-[500px]"
            />
          </div>
        </div>
      </section> */}
      {/* 
      <section className="mx-auto -mt-10 max-w-[1280px] px-6 md:px-10">
        <div className="grid gap-4 rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_25px_50px_-20px_rgba(0,0,0,0.18)] md:grid-cols-4">
          {scaleStats.map((item) => (
            <article
              key={item.label}
              className="rounded-2xl border border-slate-100 bg-slate-50 p-5 text-center"
            >
              <p className="text-3xl font-extrabold tracking-tight text-[#121212]">
                {item.value}
              </p>
              <p className="mt-2 text-[10px] font-black uppercase tracking-[0.14em] text-slate-500">
                {item.label}
              </p>
            </article>
          ))}
        </div>
      </section> */}

      <section className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 sm:py-16 md:px-10 md:py-20">
        <div className="grid items-start gap-y-6 sm:gap-y-8 lg:grid-cols-[1fr_0.9fr] lg:gap-x-16">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921] sm:text-[15px] sm:tracking-[0.3em]">
              Who We Are
            </p>
            <h2 className="mt-4 text-2xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-3xl md:text-4xl">
              A New Category
              <br />
              for Assisted Credit
            </h2>
          </div>
          <div className="hidden lg:block" aria-hidden="true" />
          <div className="h-56 w-full overflow-hidden rounded-2xl border border-[#12395d]/20 shadow-lg sm:h-64 md:h-72">
            <img
              src="/office1.jpeg"
              alt="FinnCube office"
              className="h-full w-full bg-slate-100 object-contain"
            />
          </div>
          <div className="flex min-h-56 items-center rounded-2xl border border-[#12395d]/20 bg-[#12395d] p-6 text-base leading-relaxed text-white/80 shadow-lg sm:min-h-64 sm:p-8 sm:text-lg md:h-72 md:p-10 md:text-xl">
            <p>
              FinnCube was founded to solve one core gap in financial services:
              fast digital approval with physical confidence. Our kiosk-led
              model enables users to complete secure journeys in trusted and
              assisted environments from onboarding to disbursement within 3 minutes.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 pb-14 sm:px-6 sm:pb-16 md:px-10 md:pb-20">
        <div className="rounded-[32px] border border-slate-200 bg-white p-5 shadow-[0_20px_50px_-20px_rgba(10,44,79,0.2)] sm:p-6 md:p-10">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921] sm:text-[15px] sm:tracking-[0.3em]">
            What We Do
          </p>
          <h3 className="mt-4 text-2xl font-extrabold tracking-tight text-[#0a2c4f] sm:text-3xl md:text-4xl">
            Building Reliable Assisted Loan Infrastructure
          </h3>
          <div className="mt-8 grid gap-5 md:grid-cols-3">
            <article className="rounded-2xl border border-[#12395d]/20 bg-[#12395d] p-5 md:col-span-3">
              {/* <p className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921]">
                Kiosk Journeys
              </p> */}
              <p className="mt-3 text-sm leading-relaxed text-white/75 sm:text-base md:text-lg">
                At Finncube, we focus on enabling fast, accessible, and seamless loan solutions for salaried individuals through our innovative digital kiosk model, bringing financial services closer to users in a simple and efficient way. As one of the first companies in India to introduce this concept, we are redefining how credit is delivered at scale by combining convenience with technology. Beyond this, we empower NBFCs, banks, and fintech partners by providing a robust, technology-driven platform that streamlines lending operations, integrates partners effortlessly, and enhances customer reach. Through smart workflows, data-driven decision-making, and scalable infrastructure, we simplify the complexities of the lending ecosystem and help our partners grow faster while delivering better financial experiences in an evolving digital landscape
              </p>
            </article>
            {/* <article className="rounded-2xl border border-slate-100 bg-slate-50 p-5">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921]">
                Secure Decisioning
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                Our stack combines KYC, consent capture, and policy-driven risk
                controls to deliver dependable and compliant credit outcomes.
              </p>
            </article> */}
            {/* <article className="rounded-2xl border border-slate-100 bg-slate-50 p-5">
              <p className="text-xs font-black uppercase tracking-[0.2em] text-[#e37921]">
                Partner Scale
              </p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                We help lending and deployment partners expand into high-footfall
                locations with standardized operations and real-time visibility.
              </p>
            </article> */}
          </div>
        </div>
      </section>

      {/* <section className="mx-auto max-w-[1280px] px-6 pb-20 md:px-10">
        <div className="rounded-[32px] bg-[#0a2c4f] p-8 text-white md:p-10">
          <h3 className="text-2xl font-extrabold tracking-tight md:text-3xl">
            Journey So Far
          </h3>
          <div className="mt-8 ">
            {milestones.map((item) => (
              <article
                key={item.title}
                className="rounded-2xl border border-white/10 bg-white/[0.03] p-5"
              >
                <p className="text-2xl font-extrabold text-[#e37921]">
                  {item.title}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-white/75">
                  {item.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section> */}

      {/* <section className="mx-auto max-w-[1280px] px-6 pb-20 md:px-10">
        <div className="grid gap-6 md:grid-cols-2">
          {values.map((card) => (
            <article
              key={card.title}
              className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl"
            >
              <h3 className="text-2xl font-bold tracking-tight text-[#131313]">
                {card.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-slate-600">
                {card.text}
              </p>
            </article>
          ))}
        </div>
      </section> */}

      <section className="bg-[#0a2c4f] py-14 text-white sm:py-16 md:py-20">
        <div className="mx-auto max-w-[1280px] px-4 sm:px-6 md:px-10">
          <div className="flex flex-col gap-4 text-center md:text-left">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-sky-300 sm:text-[15px] sm:tracking-[0.3em]">
              Leadership
            </p>
            <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl md:text-5xl">
              Team That Executes With Precision
            </h2>
          </div>
          <div className="mt-12 grid gap-8 lg:grid-cols-[2fr_1fr]">
            <div className="grid gap-6 md:grid-cols-2">
              {coreLeaders.map((leader) => (
                <article
                  key={leader.name}
                  className="overflow-visible rounded-3xl border border-white/10 bg-white/5"
                >
                  {/* <img
                    src={leader.image}
                    alt={leader.name}
                    className="h-69 w-full object-cover"
                  /> */}
                  <div className="p-6">
                    <div className="group relative inline-block">
                      <button
                        type="button"
                        className="cursor-default text-left text-lg font-bold sm:text-xl"
                      >
                        {leader.name}
                      </button>
                      {leader.bio && (
                        <div className="pointer-events-none absolute bottom-full left-4 right-auto z-20 mb-3 w-[min(88vw,420px)] translate-x-0 rounded-3xl bg-white p-4 text-left text-sm font-medium leading-relaxed text-[#102a8a] opacity-0 shadow-2xl transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100 sm:left-5 sm:p-5 sm:text-[15px] md:left-1/2 md:w-[420px] md:-translate-x-1/2 md:text-center lg:left-6 lg:translate-x-0 lg:text-left">
                          {leader.bio}
                          <span className="absolute left-10 top-full h-0 w-0 border-x-[10px] border-t-[10px] border-x-transparent border-t-white md:left-1/2 md:-translate-x-1/2 md:border-x-[12px] md:border-t-[12px] lg:left-12 lg:translate-x-0" />
                        </div>
                      )}
                    </div>
                    <p className="mt-1 text-sm text-sky-300">{leader.role}</p>
                  </div>
                </article>
              ))}
            </div>

            <aside className="h-fit rounded-3xl border border-white/20 bg-white/10 p-6">
              <h3 className="text-2xl font-extrabold tracking-tight text-white">
                Tech
              </h3>
              <div className="mt-5 space-y-3">
                {techTeam.map((member) => (
                  <div
                    key={member.name}
                    className="rounded-2xl border border-white/15 bg-white/5 px-4 py-3"
                  >
                    <p className="text-base font-semibold text-sky-100">
                      {member.name}
                    </p>
                    <p className="mt-1 text-sm text-sky-300">{member.role}</p>
                  </div>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-14 sm:px-6 sm:py-16 md:px-10 md:py-24">
        <div className="rounded-[40px] bg-gradient-to-r from-[#0a2c4f] to-[#11476d] p-6 text-center text-white sm:p-8 md:p-16">
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-sky-300 sm:tracking-[0.3em]">
            Build with us
          </p>
          <h2 className="mt-5 text-2xl font-extrabold tracking-tight sm:text-3xl md:text-5xl">
            We&apos;re Building the Next Decade of Assisted Lending.
          </h2>
          {/* <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-sky-100/80 md:text-base">
            Whether you are a lending partner, deployment partner, or talent
            looking to shape large-scale finncube infrastructure, FinnCube is
            open to collaborate.
          </p> */}
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            {/* <a
              href="#/company"
              className="rounded-full bg-[#e37921] px-8 py-3 text-[11px] font-black uppercase tracking-[0.15em] text-white transition-colors hover:bg-[#e37921]"
            >
              Contact Team
            </a> */}
            <a
              href="#/"
              className="rounded-full border border-white/30 px-6 py-3 text-[10px] font-black uppercase tracking-[0.1em] text-white/90 transition-colors hover:bg-white/10 sm:px-8 sm:text-[11px] sm:tracking-[0.15em]"
            >
              View Solutions
            </a>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

export default About;
